'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _DonateModal = require('./DonateModal.css');

var _DonateModal2 = _interopRequireDefault(_DonateModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DonateModal = (_dec = (0, _reactCssModules2.default)(_DonateModal2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(DonateModal, _Component);

  function DonateModal(props) {
    (0, _classCallCheck3.default)(this, DonateModal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DonateModal.__proto__ || (0, _getPrototypeOf2.default)(DonateModal)).call(this, props));

    _this.openModal = function () {
      _this.setState({ modalOpen: true });
    };

    _this.closeModal = function () {
      _this.setState({ modalOpen: false });
    };

    _this.state = {
      modalOpen: false
    };
    return _this;
  }

  (0, _createClass3.default)(DonateModal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      setTimeout(function () {
        _this2.openModal();
      }, 1);
    }
  }, {
    key: 'render',
    value: function render() {
      //
      return _react2.default.createElement(
        _reactModal2.default,
        {
          isOpen: this.state.modalOpen,
          onRequestClose: this.closeModal,
          shouldCloseOnOverlayClick: true,
          contentLabel: 'Donate',
          style: {
            overlay: {
              backgroundColor: 'rgba(0, 0, 0, 0.3)',
              zIndex: 10004
            },
            content: {
              position: 'relative',
              height: '0px',
              left: 0,
              right: 'auto',
              top: 'auto',
              bottom: 0,
              //   marginLeft                 : 'auto',
              //   marginRight                : 'auto',
              borderRadius: 0,
              boxSizing: 'border-box',
              width: '0px',
              maxWidth: '0px',
              border: '0px',
              background: 'transparent',
              overflow: 'visible',
              WebkitOverflowScrolling: 'touch',
              outline: 'none',
              //   transform                  : 'translateY(-50%)',
              padding: 0
            }
          }
        },
        _react2.default.createElement(
          'div',
          { styleName: 'donate-modal-wrap' },
          _react2.default.createElement(
            'div',
            { styleName: 'donate-modal-wrap-inner' },
            _react2.default.createElement(
              'div',
              { styleName: 'donate-modal' },
              _react2.default.createElement('div', { styleName: 'donate-modal-image visible-sm visible-md visible-lg' }),
              _react2.default.createElement(
                'div',
                { styleName: 'donate-modal-content' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'donate-modal-close-wrap' },
                  _react2.default.createElement(
                    'span',
                    {
                      styleName: 'donate-modal-close',
                      onClick: this.closeModal
                    },
                    _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-times' })
                  )
                ),
                _react2.default.createElement(
                  'h2',
                  { styleName: 'donate-modal-headline' },
                  'Today is #GivingTuesday!'
                ),
                _react2.default.createElement(
                  'p',
                  { styleName: 'donate-modal-copy' },
                  'Stand up for the right to invest in the future we want to see!'
                ),
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: _config2.default.links.donate,
                    title: 'Donate today',
                    orangebutton: true
                  },
                  _react2.default.createElement(
                    'span',
                    { styleName: 'donate-modal-button-text' },
                    'Donate today'
                  )
                ),
                _react2.default.createElement('div', null)
              )
            )
          )
        )
      );
    }
  }]);
  return DonateModal;
}(_react.Component)) || _class);
exports.default = DonateModal;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/core/DonateModal/DonateModal.js
// module id = 1307
// module chunks = 0